// Tunable UI threshold, not a scientific claim about vessel reality -
// worth exposing as a slider later if you want people to explore it.
export const HIGH_CONFIDENCE_THRESHOLD = 0.85;

export function classifyDetection(d) {
  const isHighConfidence = d.confidence >= HIGH_CONFIDENCE_THRESHOLD;
  const hasNoNearbyAis = d.ais_presence_nearby === false;
  return {
    ...d,
    // "unconfirmed" - deliberately not "dark" or "suspicious." This
    // flag means "confident detection, no corroborating AIS activity
    // nearby" - it does NOT mean AIS is absent, since GFW's coverage
    // is proven-sparse in many of these corridors (see this session's
    // findings: Hormuz, Malacca, Bab-el-Mandeb all showed zero SAR-
    // dataset coverage despite genuine AIS presence data existing).
    unconfirmed: isHighConfidence && hasNoNearbyAis,
  };
}

export function classifyDetections(detections) {
  return detections.map(classifyDetection);
}